import "./detect";

import {
  INVISIBLE_DURATION,
  INVISIBLE_DURATION_EVENT
} from "../support/tokens";

import {
  getValueAtPath,
  isFunction,
  isPlainObject,
  withProperties
} from "../../utils";

function getObjectPrototype(value) {
  if (isPlainObject(value)) {
    try {
      // Obtain the prototype of the object using `Object.getPrototypeOf`
      // (if it is available as a method), otherwise try to get it from
      // the legacy internal `__proto__` property of the object.
      return isFunction(Object.getPrototypeOf)
        ? Object.getPrototypeOf(value)
        : (
          getValueAtPath(value, "__proto__") ||
          getValueAtPath(value, "constructor.prototype")
        );
    } catch (e) {}
  }
}

const [ $broadcast, subscribe, unsubscribe ] = (() => {
  const SUBSCRIPTION_CALLBACKS = new Set();
  const SUBSCRIPTION_CALLBACK_SYMBOL = Symbol("subscription_callback");

  const __SubscriptionProto__ = Object.freeze(
    withProperties(Object.create(null), {
      unsubscribe() {
        const callback = this[SUBSCRIPTION_CALLBACK_SYMBOL];

        callback
          && SUBSCRIPTION_CALLBACKS.has(callback)
          && SUBSCRIPTION_CALLBACKS.delete(callback);
      }
    })
  );

  function broadcast(...args) {
    let _done = false;
    
    const _doneCallback = () => { _done = true };

    return (broadcast = function _broadcastFinal(...args) {
      _done = false;

      for (const callback of SUBSCRIPTION_CALLBACKS.values()) {
        if (_done === true) break;
        try { isFunction(callback) && callback(...args, _doneCallback) }
        catch (e) { console.error(e) }
      }
    })(...args);
  }

  function subscribe(callback) {
    isFunction(callback) && SUBSCRIPTION_CALLBACKS.add(callback);

    return Object.freeze(Object.create(__SubscriptionProto__, {
      [SUBSCRIPTION_CALLBACK_SYMBOL]: { value: callback }
    }));
  }

  function unsubscribe(subscription) {
    if (getObjectPrototype(subscription) === __SubscriptionProto__) {
      subscription.unsubscribe();
    }
  }

  return [ broadcast, subscribe, unsubscribe ];
})();

addEventListener(INVISIBLE_DURATION_EVENT, evt => {
  const detail = evt.detail;

  if (isPlainObject(detail) && evt.target === self) {
    const { exact, ...props } = detail;

    if (exact && exact === detail[INVISIBLE_DURATION]) {
      $broadcast(Object.freeze(withProperties(
        Object.create(null),
        { exact, ...props }
      )));
    }
  }
});

const InvisibilityTiming = Object.freeze(withProperties(Object.create(null), {
  registerCallback: subscribe,
  unregisterCallback: unsubscribe
}));

export default InvisibilityTiming;
